// extracted by mini-css-extract-plugin
module.exports = {"main-component":"teamLunch_main-component__ioISu"};